export class MqttResponse {
	price: number;
	userId: string;
	offerId: number;
	managedTime: Date;
	endTimeForItem: Date;
	acceptedOffers: number;
	active: boolean;
	overMinExpectedOffer: boolean;

	static from = (obj): MqttResponse => Object.assign(new MqttResponse(), obj);
}